/* B2B invoice nav badges, split by reason (backend
   apps/b2b_invoices/services.compute_action_breakdown → nav-badges `b2b_invoices`).
   One vocabulary for the sidebar dot (colour + hover title) and the legend on the
   list page, so the legend explains exactly what the sidebar counted. */

/** "Moje faktury B2B" — the employee's own to-dos. */
export type B2BEmployeeBadge = "missing_periods" | "rejected" | "drafts";
/** "Faktury B2B" — CEO approval queue and accounting settlement queue. */
export type B2BAdminBadge = "to_approve" | "to_settle";
export type B2BBadge = B2BEmployeeBadge | B2BAdminBadge;

export type B2BBadgeCounts = Record<B2BBadge, number>;

/** Render order on the "Moje faktury B2B" entry and in its legend — most urgent first. */
export const B2B_EMPLOYEE_BADGES: B2BEmployeeBadge[] = [
  "missing_periods",
  "rejected",
  "drafts",
];

export const B2B_BADGE_LABELS: Record<B2BBadge, string> = {
  missing_periods: "brak faktury za miesiąc na B2B — minął termin (5. dzień kolejnego miesiąca)",
  rejected: "faktura odrzucona — popraw i złóż ponownie",
  drafts: "szkic — faktura zapisana, ale jeszcze niezłożona",
  to_approve: "faktura złożona — czeka na Twoje zatwierdzenie",
  to_settle: "faktura do zaksięgowania, przekazania do opłaty lub oznaczenia jako opłacona",
};

/* Sidebar tooltip = the legend label with a capital, so both places read the same. */
export const B2B_BADGE_TITLES = Object.fromEntries(
  Object.entries(B2B_BADGE_LABELS).map(([k, v]) => [k, v.charAt(0).toUpperCase() + v.slice(1)]),
) as Record<B2BBadge, string>;

/* Sidebar dot colours. Rejected is rose like the "Odrzucona" status pill; the
   admin entry keeps the red it always had. */
export const B2B_BADGE_COLORS: Record<B2BBadge, "red" | "rose" | "amber"> = {
  missing_periods: "red",
  rejected: "rose",
  drafts: "amber",
  to_approve: "red",
  to_settle: "red",
};

/* Same classes as the sidebar `Dot`, so the legend chip looks exactly like the badge. */
export const B2B_BADGE_CHIP_CLASSES: Record<"red" | "rose" | "amber", string> = {
  red: "bg-[var(--color-primary)] text-[var(--color-text-inverse)]",
  rose: "bg-rose-500 text-white",
  amber: "bg-amber-500 text-white",
};
